import { defineMessages } from 'react-intl';

export default defineMessages({
  tocTitle: {
    id: 'site.pages.docs.article.toc.title',
    defaultMessage: 'On this page',
    description: 'title of the table of contents',
  },
});
